import { useQuery } from 'react-query';
import { AxiosResponse } from 'axios';
import { getCategories } from 'services/category.service';

export const getCategoryListQueryKey = 'getCategories';
export const useCategoryList = (search?: string) => useQuery(
  [getCategoryListQueryKey, search],
  () => getCategories(search).then((result: AxiosResponse<Category[]>) => result.data),
  { refetchOnWindowFocus: false, retry: false, cacheTime: 0 },
) as AxiosResponse<Category[], Error>;
